<template>
  <div>
    <b-carousel id="carousel1"
                style="text-shadow: 1px 1px 8px #000; "
                controls
                indicators
                background="black"
                :interval="4000"
                img-width="1024"
                img-height="450"
                v-model="slide"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
    >

      <!-- Text slides with image -->
      <b-carousel-slide class="imageap"
                        img-src="/assets/derecho-civil.jpg"
      ><h1>Legiox</h1></b-carousel-slide>

      <!-- Slides with custom text -->
      <b-carousel-slide class="imageap" img-src="/assets/comercial2.jpg">
        <h1>Genere sus contratos facilmente</h1>
      </b-carousel-slide>

      <!-- Slides with image only -->
      <b-carousel-slide class="imageap" img-src="assets/contrato-laboral-2.jpg">
        <h1>Servicios empresariales</h1>
      </b-carousel-slide>

      <!-- Slides with img slot -->
      <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
      <!-- <b-carousel-slide>
        <img slot="img" class="d-block img-fluid w-100" width="1024" height="480"
             src="https://picsum.photos/1024/480/?image=55" alt="image slot">
      </b-carousel-slide> -->

      <!-- Slide with blank fluid image to maintain slide aspect ratio -->
      <!-- <b-carousel-slide caption="Blank Image" img-blank img-alt="Blank image">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
          eros felis, tincidunt a tincidunt eget, convallis vel est. Ut pellentesque
          ut lacus vel interdum.
        </p>
      </b-carousel-slide> -->

    </b-carousel>

  </div>
</template>

<script>
export default {
  data () {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    }
  }
}
</script>

<style scoped>
.imageap{
    max-height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/navigate/carrousel.vue